import React, { useContext, useEffect, useState } from "react";
import { Toast } from "primereact/toast";
import { useForm } from "react-hook-form";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { getItemStorage } from "../Localstorage/useLocalStorage";
import { TreeSelect } from "primereact/treeselect";

// context
import { UserData } from "../contexts/UserInfoContext";

// icon
import { HiOutlineTrash } from "react-icons/hi2";

// components
import Header from "../components/Header/Header";
import MobileNavbar from "../components/Header/Mobile/MobileNavbar";
import MobileHeader from "../components/Header/Mobile/MobileHeader";
import ProductSidebarWrapper from "../components/Product/ProductPage/ProductSidebarWrapper";
import Footer from "../components/Footer/Footer";
import {
  addressObject,
  idGenerator,
  tagsObject,
  toFarsiNumber,
} from "../helper/helper";
import Input from "../components/shared/Form/Input";
import CartItem from "../components/Cart/CartItem";

// API
import { deleteData, getData, postData } from "../services/API";
import { useRef } from "react";
import Loading from "../components/shared/Loading";
import { Link, Navigate, useNavigate } from "react-router-dom";

// contexts
import { CartDataContext } from "../contexts/CartContext";
import ScrollTop from "../components/shared/ScrollTop";
import Compare from "../components/Compare/Compare";
import CircleLoading from "../components/shared/CircleLoading";

const Cart = () => {
  const { register, getValues } = useForm();
  const { user } = useContext(UserData);
  const { cart, updateCart, loaded, err } = useContext(CartDataContext);
  const [loading, setLoading] = useState(true);
  const [province, setProvince] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [cities, setCities] = useState([]);
  const [selectedCities, setSelectedCities] = useState(null);
  const [errMsg, setErrMsg] = useState([]);
  const [orderIsSaved, setOrderIsSaved] = useState(false);
  const [saveOrderLoading, setSaveOrderLoading] = useState(false);
  const [order, setOrder] = useState([]);
  const [newAddress, setNewAddress] = useState(false);
  const [provinceLoading, setProvinceLoading] = useState(false);
  const [citiesLoading, setCitiesLoading] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [discount, setDiscount] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [payLoading, setPayLoading] = useState(false);
  const [paySubmit, setPaySubmit] = useState({});
  const [code, setCode] = useState("");
  const [codeLoading, setCodeLoading] = useState(false);
  const [wallet, setWallet] = useState(false);

  const token = getItemStorage("token");

  const toastErr = useRef(null);
  const toastApplyErr = useRef(null);
  const toastSaveOrder = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    token
      ? setTimeout(() => {
          setLoading(false);
        }, 2500)
      : setLoading(false);
  }, [cart, loading, loaded, err]);

  const saveOrder = () => {
    if (!orderIsSaved) {
      setSaveOrderLoading(true);
      setProvinceLoading(true);
      postData("/shop/order/save", {})
        .then((res) => {
          setOrderIsSaved(true);
          setOrder(res.data.order);
          setAddresses(addressObject(res.data.addresses));
          setSelectedAddress(addressObject(res.data.addresses)[0]);
          res.data.addresses.length === 0 && setNewAddress(true);
          res.data.discount && setCode(res.data.discount.code);

          // get province
          getData("/get-provinces", {})
            .then((res) => {
              setProvinceLoading(false);
              setProvince(tagsObject(res.data));
            })
            .catch((err) => {
              setProvinceLoading(false);
            });

          setSaveOrderLoading(false);
        })
        .catch((err) => {
          setSaveOrderLoading(false);
        });
    } else {
      setPayLoading(true);
      setErrMsg(null);
      postData("/shop/order/pay", {
        order_id: order.id,
        city_id: newAddress ? selectedCities : selectedAddress.city.id,
        province: newAddress ? selectedProvince : selectedAddress.province.id,
        address: newAddress ? getValues("address") : selectedAddress.address,
        postal_code: newAddress
          ? getValues("postal_code")
          : selectedAddress.postal_code,
        description: getValues("description"),
        usewallet: true,
        ...(code && { code }),
      })
        .then((res) => {
          if (res.data?.gateway) {
            setPaySubmit(res.data.gateway);

            setTimeout(() => {
              document.getElementById("pay_form").submit();
            }, 200);
          }

          if (res.data.paid) {
            navigate("/order/payment?status=success");
          }

          toastErr.current.show({
            severity: "success",
            summary: "سفارش با موفقیت ثبت شد",
            detail: "درحال انتقال شما به درگاه پرداخت...",
            life: 3500,
          });
        })
        .catch((err) => {
          setErrMsg(err.response.data);
          setPayLoading(false);

          toastErr.current.show({
            severity: "error",
            summary: "خطا هنگام انتقال به درگاه",
            detail: "خطایی هنگام انتقال شما به درگاه پیش آمده",
            life: 3500,
          });
        });
    }
  };

  const selectProvinceHandler = (e) => {
    setSelectedProvince(e.value);
    setCitiesLoading(true);

    postData("/get-cities", { id: e.value })
      .then((res) => {
        setCitiesLoading(false);
        setCities(tagsObject(res.data));
      })
      .catch((err) => {
        setCitiesLoading(false);
      });
  };
  // /shop/discount/apply

  const submitDiscountCode = () => {
    setCodeLoading(true);

    postData("/shop/discount/apply", {
      code,
      order_id: order.id,
    })
      .then((res) => {
        setDiscount(res.data);
        setCodeLoading(false);

        toastErr.current.show({
          severity: "success",
          summary: "با موفقیت انجام شد",
          detail: "کد بورسیه بر روی سفارش شما اعمال شد.",
          life: 3500,
        });
      })
      .catch((err) => {
        toastErr.current.show({
          severity: "error",
          summary: "خطا هنگام ثبت کد بورسیه",
          detail: err.response.data.code,
          life: 3500,
        });

        setCodeLoading(false);
      });
  };

  const backToCart = () => {
    setOrderIsSaved(false);
    setErrMsg([]);
    setDiscount({});
    setSaveOrderLoading(false);
    setPayLoading(false);
  };

  const deleteDiscountHandler = () => {
    setCodeLoading(true);

    postData("/shop/discount/remove", { order_id: order.id }).then((res) => {
      setCode("");

      postData("/shop/order/save", {})
        .then((res) => {
          setOrderIsSaved(true);
          setOrder(res.data.order);
          setAddresses(addressObject(res.data.addresses));
          setSelectedAddress(addressObject(res.data.addresses)[0]);
          res.data.addresses.length === 0 && setNewAddress(true);
          res.data.discount && setCode(res.data.discount.code);
          setCodeLoading(false);

          setDiscount({});
        })
        .catch((err) => {
          setSaveOrderLoading(false);
        });

      toastErr.current.show({
        severity: "success",
        summary: "با موفقیت انجام شد",
        detail: "کد بورسیه بر از سفارش شما حذف شد.",
        life: 3500,
      });
    });
  };

  return (
    <div className="flex flex-col items-center justify-center mx-auto">
      <Header />
      <MobileNavbar />
      <MobileHeader />
      <Toast ref={toastErr} />
      <Toast ref={toastApplyErr} />
      <Compare />
      <ScrollTop />

      <div className="w-full xl:max-w-[1300px] flex flex-col justify-center mt-5 gap-8 mb-20 px-3">
        <ProductSidebarWrapper
          className="!w-full"
          titleClassName="!text-[20px]"
          contentClassName="!mt-[6px]"
          title="سبد خرید"
          line={true}
        ></ProductSidebarWrapper>

        {paySubmit?.action && (
          <form
            id="pay_form"
            action={`https://sadad.shaparak.ir/VPG/Purchase?Token=${paySubmit.inputs.Token}`}
            method="GET"
          >
            <input type="hidden" name="Token" value={paySubmit.inputs.Token} />
          </form>
        )}

        {/* cart content */}
        {loading ? (
          <Loading />
        ) : cart.items?.length > 0 ? (
          <div className="flex flex-col xl:flex-row gap-8">
            {/* product on cart */}
            <div className="flex w-full gap-6 flex-col-reverse h-fit rounded-xl bg-[#222] p-4 shadow-[0px_5px_25px_rgba(79,105,139,.09)]">
              {/* {orderIsSaved && (
                <div className="w-full flex flex-col gap-5">
                  <div className="flex flex-col w-full gap-3">
                    <div className="w-full flex flex-col gap-4">
                      {!saveOrderLoading && addresses?.length > 0 && (
                        <div className="flex flex-col gap-3">
                          <label className="">آدرس های شما :</label>

                          <div className="grid grid-cols-1 gap-3">
                            {addresses.map((address, i) => (
                              <div
                                key={address.key}
                                className={`field-radiobutton pr-3 ${
                                  selectedAddress.key === address.key
                                    ? "ring-2 ring-blue-600"
                                    : "ring-2 ring-gray-100"
                                } rounded-xl h-11 flex items-center gap-2 transition-all duration-300`}
                              >
                                <RadioButton
                                  inputId={address.key}
                                  name="prev_address"
                                  value={address}
                                  onChange={(e) => setSelectedAddress(e.value)}
                                  checked={selectedAddress?.key === address.key}
                                />
                                <label
                                  htmlFor={address.key}
                                  className={`w-full h-full ${
                                    selectedAddress.key === address.key
                                      ? "text-blue-600"
                                      : "text-gray-700"
                                  } cursor-pointer flex items-center`}
                                >
                                  <div className="flex items-center gap-4">
                                    <span>{`${address.province.name}, ${address.city.name}, ${address.address}`}</span>
                                    <span className="text-sm">{`نام و نام خانوادگی : ${
                                      address?.name + " " + address?.family_name
                                    }`}</span>

                                    <div className="flex items-center gap-1">
                                      <span className="text-sm">کد پستی :</span>
                                      <span>{address.postal_code}</span>
                                    </div>
                                  </div>
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {!saveOrderLoading && order.addresses?.length > 0 && (
                        <div className="public-post flex items-center gap-2 mb-2">
                          <Checkbox
                            className="w-10"
                            inputId="new-address"
                            checked={newAddress}
                            onChange={(e) => setNewAddress(e.checked)}
                          ></Checkbox>
                          <label
                            htmlFor="new-address"
                            className="cursor-pointer"
                          >
                            آدرس جدید
                          </label>
                        </div>
                      )}
                    </div>

                    {!saveOrderLoading && newAddress && (
                      <div className="flex flex-col w-full gap-5">
                        <div className="flex items-center gap-5">
                          <div className="w-full flex flex-col gap-2">
                            <label className="text-gray-200">استان شما</label>
                            {provinceLoading ? (
                              <Loading />
                            ) : (
                              <TreeSelect
                                options={province}
                                value={selectedProvince}
                                onChange={selectProvinceHandler}
                                placeholder="استان خود را انتخاب کنید"
                                selectionMode="single"
                                metaKeySelection={false}
                                className={`w-full !bg-[#222222] !rounded-xl !h-[50px] ${
                                  errMsg && errMsg["province"]
                                  ? "ring-1 ring-red-600 focus:ring-red-600 bg-[#222222]"
                                  : "focus:ring-yellow-700 bg-[#222222]"
                              } w-full h-[50px] rounded-xl px-4 outline-none text-gray-200 focus:ring-2 focus:shadow-lg !border font-[YekanBakh] !border-gray-800 transition-all duration-200`}
                                panelClassName="select-tag-product"
                              ></TreeSelect>
                            )}

                            {errMsg && (
                              <span className="text-sm text-red-600">
                                {errMsg["province"]}
                              </span>
                            )}
                          </div>

                          <div className="w-full flex flex-col gap-2">
                            <label className="text-gray-200">شهر شما</label>
                            {citiesLoading ? (
                              <Loading />
                            ) : (
                              <TreeSelect
                                options={cities}
                                value={selectedCities}
                                onChange={(e) => setSelectedCities(e.value)}
                                placeholder="شهر خود را انتخاب کنید"
                                selectionMode="single"
                                metaKeySelection={false}
                                className={`w-full !bg-[#222222] !rounded-xl !h-[50px] ${
                                  errMsg && errMsg["city_id"]
                                  ? "ring-1 ring-red-600 focus:ring-red-600 bg-[#222222]"
                                  : "focus:ring-yellow-700 bg-[#222222]"
                              } w-full h-[50px] rounded-xl px-4 outline-none text-gray-200 focus:ring-2 focus:shadow-lg !border font-[YekanBakh] !border-gray-800 transition-all duration-200`}
                                panelClassName="select-tag-product"
                              ></TreeSelect>
                            )}

                            {errMsg && (
                              <span className="text-sm text-red-600">
                                {errMsg["city_id"]}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="w-full flex gap-5">
                          <Input
                            element={"input"}
                            label={"آدرس شما"}
                            placeHolder={"آدرس خود را وارد کنید"}
                            wrapperClass={"!w-[60%]"}
                            register={{ ...register("address") }}
                            error={errMsg && errMsg["address"]}
                          />
                          <Input
                            element={"input"}
                            label={"کد پستی"}
                            placeHolder={"کد پستی خود را وارد کنید"}
                            register={{ ...register("postal_code") }}
                            wrapperClass={"!w-[40%]"}
                            error={errMsg && errMsg["postal_code"]}
                          />
                        </div>
                      </div>
                    )}

                    <div className="w-full flex gap-5">
                      <Input
                        element={"input"}
                        label={"توضیحات"}
                        placeHolder={"توضیحات خود را بنویسید"}
                        wrapperClass={"!w-[60%]"}
                        register={{ ...register("description") }}
                      />
                      <Input
                        element={"input"}
                        label={"شماره تلفن"}
                        value={toFarsiNumber(user.user.phone_number)}
                        placeHolder={"شماره تلفن خود را وارد کنید"}
                        register={{ ...register("phone_number") }}
                        className="disabled:opacity-80 cursor-not-allowed text-lg"
                        wrapperClass={"!w-[40%]"}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              )} */}

              <div className="flex flex-col gap-6 items-center">
                {orderIsSaved && (
                  <h2 className="text-xl font-black text-gray-200">
                    سفارش شما
                  </h2>
                )}

                <div className="w-full flex-col h-fit relative flex items-center border border-gray-800 px-2 rounded-lg">
                  {deleteLoading && (
                    <div className="absolute w-full h-full bg-black bg-opacity-20 rounded-lg flex justify-center items-center backdrop-blur z-50">
                      <Loading />
                    </div>
                  )}

                  <div className="table-scroll w-full overflow-x-auto">
                    <table class="GeneratedTable !bg-[#222] table-auto min-w-[600px]">
                      <thead className="border-b border-gray-800">
                        <tr>
                          {!orderIsSaved && <th></th>}
                          <th className="text-gray-200">محصول</th>
                          <th className="text-gray-200">قیمت</th>
                          <th className="text-gray-200">تعداد</th>
                          <th className="text-gray-200">مجموع</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cart.items?.map((cartProduct) => (
                          <tr
                            key={cartProduct.id}
                            className="relative border-b border-gray-800 pb-3"
                          >
                            <CartItem
                              order={orderIsSaved}
                              cartProduct={cartProduct}
                              setDeleteLoading={setDeleteLoading}
                            />
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="flex flex-col gap-2 lg:flex-row justify-between w-full py-5">
                    <div
                      className={`flex ${
                        orderIsSaved
                          ? "opacity-100 visible"
                          : "opacity-0 invisible"
                      } justify-start w-full gap-5 items-center`}
                    >
                      <div className="min-w-[208px]">
                        <Input
                          element={"input"}
                          placeHolder={"کد بورسیه"}
                          value={code}
                          onChange={(e) => setCode(e.target.value)}
                        />
                      </div>

                      {code &&
                      (discount.cost ||
                        discount.cost === 0 ||
                        order.discount ||
                        discount.cost === 0) ? (
                        <button
                          className="bg-gradient-to-tl from-red-700 to-red-400 flex justify-center items-center rounded-xl shadow-lg text-white text-sm w-full lg:w-32 h-11 transition-all duration-300"
                          onClick={deleteDiscountHandler}
                        >
                          {codeLoading ? (
                            <CircleLoading />
                          ) : (
                            <span>حذف کد بورسیه</span>
                          )}
                        </button>
                      ) : (
                        <button
                          className="bg-gradient-to-tl from-yellow-900 to-yellow-500 flex justify-center items-center rounded-xl shadow-lg text-white text-sm w-full lg:w-32 h-11 transition-all duration-300"
                          onClick={submitDiscountCode}
                        >
                          {codeLoading ? (
                            <CircleLoading />
                          ) : (
                            <span>اعمال کد بورسیه</span>
                          )}
                        </button>
                      )}
                    </div>

                    <div>
                      <button
                        className="bg-gradient-to-tl from-yellow-900 to-yellow-500 rounded-xl shadow-lg text-white text-sm w-full lg:w-40 h-11 transition-all duration-300"
                        onClick={updateCart}
                      >
                        <span>بروزرسانی سبد خرید</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* checkout */}
            <ProductSidebarWrapper
              className="lg:!max-w-[355px] !min-w-[355px] w-full !h-fit"
              title="جمع کل سبد خرید"
              line={true}
            >
              <div className="w-full flex flex-col gap-6 px-2">
                <div className="flex flex-col gap-2">
                  <span className="">جمع کل پکیج ها :</span>
                  <span className="text-[17px]">
                    {toFarsiNumber(cart.cost)} تومان
                  </span>
                </div>

                <div className="flex flex-col gap-2">
                  <span className="">ارزش افزوده :</span>
                  <span className="text-[17px]">
                    {toFarsiNumber(
                      discount.tax
                        ? discount.tax
                        : order.tax
                        ? order.tax
                        : cart.tax
                    )}{" "}
                    تومان
                  </span>
                </div>

                {code &&
                (discount.cost ||
                  discount.cost === 0 ||
                  order.discount ||
                  discount.cost === 0) ? (
                  <>
                    <div className="flex flex-col gap-2">
                      <span className="">مبلغ کم شده :</span>
                      <span className="text-[17px] text-red-500">
                        {toFarsiNumber(
                          discount.discount ? discount.discount : order.discount
                        )}{" "}
                        تومان
                      </span>
                    </div>

                    <div className="flex flex-col gap-2">
                      <span className="">جمع پکیج های شما بعد از بورسیه :</span>
                      <span className="text-[17px] text-green-500">
                        {toFarsiNumber(
                          discount.cost || discount.cost === 0
                            ? discount.cost
                            : order.cost -
                                Math.round(order.discount) +
                                order?.tax
                        )}{" "}
                        تومان
                      </span>
                    </div>
                  </>
                ) : (
                  ""
                )}

                {discount?.type === "installment" && (
                  <div className="flex flex-col gap-2 p-2 rounded-lg border border-gray-800">
                    <span className="font-semibold text-gray-200">
                      نوع کد: اقساط
                    </span>
                    <div className="grid grid-cols-2 gap-2">
                      <div className="flex flex-col gap-1">
                        <span className="">مبلغ کل:</span>
                        <span className="text-[13px] text-gray-200">
                          {toFarsiNumber(Math.round(Number(discount.installment?.total_amount || 0)))} تومان
                        </span>
                      </div>
                      <div className="flex flex-col gap-1">
                        <span className="">پیش‌پرداخت:</span>
                        <span className="text-[13px] text-green-500">
                          {toFarsiNumber(Math.round(Number(discount.order?.payable_now || discount.installment?.down_payment || 0)))} تومان
                        </span>
                      </div>
                      <div className="flex flex-col gap-1">
                        <span className="">تعداد اقساط:</span>
                        <span className="text-[13px] text-gray-200">
                          {toFarsiNumber(Math.round(Number(discount.installment?.num_installments || 0)))}
                        </span>
                      </div>
                      <div className="flex flex-col gap-1">
                        <span className="">بازه پرداخت:</span>
                        <span className="text-[13px] text-gray-200">
                          {toFarsiNumber(Math.round(Number(discount.installment?.interval_value || 0)))}{" "}
                          {discount.installment?.interval_unit === "day" ? "روز" : "ماه"}
                        </span>
                      </div>
                    </div>
                    <div className="w-full flex flex-col gap-1">
                      {(discount.installment?.schedules_preview || []).map((s) => (
                        <div key={s.seq} className="w-full flex items-center justify-between gap-2 border border-gray-800 bg-[#1f1f1f] rounded-xl p-2">
                          <div className="flex items-center gap-3">
                            <span className="px-2 py-1 rounded-md bg-amber-100 text-amber-700 text-xs">
                              {toFarsiNumber(Math.round(Number(s.seq)))}
                            </span>
                            <div className="flex flex-col">
                              <span className="text-xs text-gray-400">سررسید</span>
                              <span className="text-[13px] text-gray-200">
                                {new Intl.DateTimeFormat("fa-IR", {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                }).format(new Date(s.due_at))}
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col text-left">
                            <span className="text-xs text-gray-400">مبلغ قسط</span>
                            <span className="text-[13px] text-gray-200">
                              {toFarsiNumber(Math.round(Number(s.amount)))} تومان
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* wallet payment */}
                <div className="flex flex-col gap-2">
                  <div className="public-post flex items-center gap-2">
                    <Checkbox
                      inputId="wallet-pay"
                      checked={wallet}
                      onChange={(e) => setWallet(e.checked)}
                      disabled={!(user?.user && user?.user?.wallet > 0)}
                    ></Checkbox>
                    <label
                      htmlFor="wallet-pay"
                      className={`w-full flex items-center ${
                        user?.user?.wallet > 0
                          ? "cursor-pointer"
                          : "cursor-not-allowed"
                      } `}
                    >
                      <span>پرداخت با کیف پول</span>
                    </label>
                  </div>
                  <span className="text-xs text-gray-400 block mr-1">
                   موجودی: {toFarsiNumber(user?.user?.wallet || 0)} تومان
                  </span>
                  {(() => {
                    let baseTotal = order.discount
                      ? Math.round(
                          (order.cost || 0) -
                            Math.round(order.discount || 0) +
                            Math.round(order.tax || 0)
                        )
                      : Math.round(
                          (discount.cost || discount.cost === 0
                            ? discount.cost
                            : (cart.cost || 0) + (cart.tax || 0)) || 0
                        );
                    if (discount?.type === "installment") {
                      baseTotal = Math.round(discount.order?.payable_now || baseTotal);
                    }
                    const walletAmount = wallet
                      ? Math.round(user?.user?.wallet || 0)
                      : 0;
                    const payable = Math.max(0, baseTotal - walletAmount);
                    const shortage = baseTotal - (user?.user?.wallet || 0);
                    return (
                      <div className="flex flex-col gap-2">
                        {wallet && (
                          <>
                            <div className="flex flex-col gap-2 my-2">
                              <span className="">مبلغ کسر از کیف پول:</span>
                              <span className="text-[15px] text-green-500">
                                {toFarsiNumber(
                                  Math.min(baseTotal, walletAmount)
                                )}{" "}
                                تومان
                              </span>
                            </div>
                            {shortage > 0 && (
                              <div className="flex justify-between gap-2 items-center">
                                <span className="text-sm text-red-600">
                                  صورتحساب از موجودی کیف پول شما بیشتر است
                                </span>
                              </div>
                            )}
                            <div className="flex flex-col gap-2">
                              <span className="">
                                مبلغ قابل پرداخت پس از کیف پول:
                              </span>
                              <span className="text-[17px]">
                                {toFarsiNumber(payable)} تومان
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    );
                  })()}
                </div>

                <div className="flex flex-col gap-2">
                  <span className="">جمع کل + ارزش افزوده :</span>
                  <span className="text-[17px]">
                    {(() => {
                      let baseTotal = order.discount
                        ? Math.round(
                            (order.cost || 0) -
                              Math.round(order.discount || 0) +
                              Math.round(order.tax || 0)
                          )
                        : Math.round(
                            (discount.cost || discount.cost === 0
                              ? discount.cost
                              : (cart.cost || 0) + (cart.tax || 0)) || 0
                          );
                      if (discount?.type === "installment") {
                        baseTotal = Math.round(discount.order?.payable_now || baseTotal);
                      }
                      const walletAmount = wallet
                        ? Math.round(user?.user?.wallet || 0)
                        : 0;
                      const payable = Math.max(0, baseTotal - walletAmount);
                      return toFarsiNumber(payable);
                    })()}{" "}
                    تومان
                  </span>
                </div>
              </div>

              <div className="flex flex-col gap-3">
                <button
                  onClick={saveOrder}
                  className={`bg-gradient-to-tl ${
                    orderIsSaved
                      ? "from-green-600 to-green-300"
                      : "from-yellow-900 to-yellow-500"
                  } rounded-xl shadow-lg mt-3 text-white w-full h-11 transition-all duration-300`}
                  type="submit"
                >
                  {saveOrderLoading || payLoading ? (
                    <Loading color={"before:!bg-white"} />
                  ) : (
                    <span>{orderIsSaved ? "ثبت و پرداخت" : "ادامه خرید"}</span>
                  )}
                </button>

                {orderIsSaved && (
                  <button
                    onClick={backToCart}
                    className="bg-gradient-to-tl from-yellow-900 to-yellow-500 rounded-xl shadow-lg text-white w-full h-11 transition-all duration-300"
                    type="submit"
                  >
                    برگشت
                  </button>
                )}
              </div>
            </ProductSidebarWrapper>
          </div>
        ) : !token || !user.user ? (
          <div className="flex flex-col gap-5 mb-24">
            <div className="w-full flex flex-col gap-5 bg-[#222] py-5 rounded-lg shadow-[0px_5px_25px_rgba(79,105,139,.09)] px-4">
              <h2 className="text-gray-200">
                برای افزودن محصول به سبد خرید ابتدا وارد شوید
              </h2>
            </div>
            <Link
              to="/auth"
              className="bg-gradient-to-tl from-yellow-900 to-yellow-500 rounded-xl shadow-lg flex justify-center items-center text-white text-sm w-32 h-11 transition-all duration-300"
              type="submit"
            >
              <span>ورود یا ثبت نام</span>
            </Link>
          </div>
        ) : (
          <div className="flex flex-col gap-5 mb-24">
            <div className="w-full flex flex-col gap-5 bg-[#222] py-5 rounded-lg shadow-[0px_5px_25px_rgba(79,105,139,.09)] px-4">
              <h2 className="text-gray-200">سبد خرید شما خالی میباشد</h2>
            </div>
            <Link
              to="/shop"
              className="bg-gradient-to-tl from-yellow-900 to-yellow-500 rounded-xl shadow-lg flex justify-center items-center text-white text-sm w-40 h-11 transition-all duration-300"
              type="submit"
            >
              <span>بازگشت به فروشگاه</span>
            </Link>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Cart;
